
import { Step } from "@/lib/types";

export const howToUseDashboardStep: Step = {
  id: "how-to-use-dashboard",
  type: "step",
  title: "Welcome, here's how to use the reposter dashboard",
  description: `
  → Access the reposter dashboard.

  → Download content.

  → Download all the images on your phone.

  → Create the post accordingly.

  → 🚨 Make sur you create the slideshow with first the title, then the questions, then the CTA.
  → Add the music.

  → Copy post title and add post title from the reposter dashboard.

  → Copy # and add #.

  → Post or add in drafts.

  → 🚨 Change the post status in the Creator Dashboard. This is important so we can track the work and pay you. We also run an automation to check views after 7d for future bonuses.

  Here are videos on how to download content and post:
  `,
  videos: [
    {
      title: "Step 1: Download content and post",
      src: "step1.mp4"
    },
    {
      title: "Step 2: Mark content as published",
      src: "step2.mp4"
    }
  ],
  buttonText: "Continue"
};
